import { jsx as u } from "react/jsx-runtime";
import h from "react";
import { ui as d } from "../ui.js";
import { clsx as c } from "../../utils/clsx.js";
import '../../assets/Island.css';const a = "_root_aa951_1", w = "_grow_aa951_15", t = {
  root: a,
  grow: w,
  "no-round-border-top-left": "_no-round-border-top-left_aa951_19",
  "no-round-border-top-right": "_no-round-border-top-right_aa951_22",
  "no-round-border-bottom-left": "_no-round-border-bottom-left_aa951_25",
  "no-round-border-bottom-right": "_no-round-border-bottom-right_aa951_28"
};
var R = /* @__PURE__ */ ((o) => (o[o.TopLeft = 1] = "TopLeft", o[o.TopRight = 2] = "TopRight", o[o.BottomLeft = 4] = "BottomLeft", o[o.BottomRight = 8] = "BottomRight", o[o.Top = 3] = "Top", o[o.Left = 5] = "Left", o[o.Right = 10] = "Right", o[o.Bottom = 12] = "Bottom", o[o.All = 15] = "All", o))(R || {});
const s = h.forwardRef(function(f, e) {
  const {
    grow: _ = !1,
    widthQ: i = 0,
    straightCorner: r = 0,
    children: b,
    className: g
  } = f, p = c(t.root, g, {
    [t.grow]: _,
    [t["no-round-border-top-left"]]: r & 1,
    [t["no-round-border-top-right"]]: r & 2,
    [t["no-round-border-bottom-left"]]: r & 4,
    [t["no-round-border-bottom-right"]]: r & 8
    /* BottomRight */
  }), m = {};
  return i > 0 && (m.width = d.q(i)), /* @__PURE__ */ u("div", { className: p, style: m, ref: e, children: b });
});
export {
  s as Island,
  R as IslandCorner
};
